import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";

import Instruction from "TaskDialogCommon/Instruction";
import Warning from "TaskDialogCommon/Warning";
import { CityNumberSelector } from "TaskDialogCommon/CityNumberSelector";
import { MapCoordInput } from "TaskDialogCommon/MapCoordInput";
import { TroopTypeSelector } from "TaskDialogCommon/TroopTypeSelector";
import { getLastConfigForTask } from "Utils/Common";

const taskname = "reassignrss";

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    const initialState = {
      taskConfig: {
        accountdetail: accountdetailrow,
        sourceCityNumber: "",
        destinationX: 0,
        destinationY: 0,
        unboxtroops: true,
        selectedTroop: null,
      },
    };
    logger.log(`loading ${taskname} dialog`, props);
    this.loadStoredData(initialState, props);
    logger.log("initialState after load", initialState);
    this.state = initialState;
  }

  validate = () => {
    const { taskConfig } = this.state;
    logger.log("taskConfig", taskConfig);
    if (
      taskConfig.destinationX === undefined ||
      taskConfig.destinationX <= 0 ||
      taskConfig.destinationX > 800 ||
      taskConfig.destinationY === undefined ||
      taskConfig.destinationY <= 0 ||
      taskConfig.destinationY > 800
    ) {
      alert("Destination City Coords should be between 1 and 800");
      return;
    }
    if (taskConfig.sourceCityNumber === "") {
      alert("Please select a source city to transfer rss from.");
      return;
    }
    return true;
  };

  loadStoredData = (initialState, props) => {
    const { taskConfig } = initialState;
    try {
      const { AccountDetailData: accountdetail } = props;
      var storeddata = getLastConfigForTask(taskname);
      logger.log("storeddata", storeddata, accountdetail);
      if (storeddata) {
        taskConfig.sourceCityNumber = storeddata.sourceCityNumber;
        taskConfig.destinationX = storeddata.destinationX;
        taskConfig.destinationY = storeddata.destinationY;
        taskConfig.unboxtroops = storeddata.unboxtroops;
        if (storeddata.selectedTroop) {
          taskConfig.selectedTroop = storeddata.selectedTroop;
        }
      }
    } catch (e) {
      logger.log(e);
    }
  };

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  render = () => {
    const {
      setValue,
      validate,
      state: { taskConfig },
      props: { AccountDetailData },
    } = this;

    return (
      <TaskDialog heading={"Reassign Rss"}>
        <CityNumberSelector
          label={"Source City"}
          param={"sourceCityNumber"}
          taskConfig={taskConfig}
          setValue={setValue}
          AccountDetailData={AccountDetailData}
        />
        <MapCoordInput
          label={"Destination City Coords"}
          paramX={"destinationX"}
          paramY={"destinationY"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <TroopTypeSelector
          label={"Troop To Use(Will user Mammoths if nothing selected)"}
          param={"selectedTroop"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <TaskCheckBox
          label={"Auto Unbox Troops Needed"}
          param={"unboxtroops"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <Instruction>
          *Before running this task please try to ensure both the cities are
          close to each other. This way the reassign will use 1 min hour glasses
          and save the bigger hour glasses :-)
        </Instruction>
        <Warning>
          *You will need atleast a full march of Pack Mammoths to run this task.
          Auto unbox will unbox required units if they are not present in city.
        </Warning>
        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Reassign Rss"}
          validate={validate}
        />
      </TaskDialog>
    );
  };
}
